/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum ContextMode {
    MAIN = 6,  // Formerly at.cdes.gwt.dto.person.PersonVariablesDTO.PRESELECTED_TAB_MAIN
    BUEK = 7   // Formerly at.cdes.gwt.dto.person.PersonVariablesDTO.PRESELECTED_TAB_PN_MAIN
}
